import Icon from '../../components/Icon.vue'

Icon.register({"brands/buysellads":{"width":448,"height":512,"paths":[{"d":"M224 150.7L266.9 311.4H181.1L224 150.7zM448 80V432C448 458.5 426.5 480 400 480H48C21.5 480 0 458.5 0 432V80C0 53.5 21.5 32 48 32H400C426.5 32 448 53.5 448 80zM382.7 405.3L288.2 106.6H159.8L65.3 405.3H156L267.7 313.7 291.9 405.3H382.7z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/buysellads.js
// module id = LpHN
// module chunks = 0